import golfAndGrowPatio1 from "assets/images/pages/golf-and-grow/patio_1.jpg";
import golfAndGrowPatio2 from "assets/images/pages/golf-and-grow/patio_2.jpg";
import golfAndGrowPatio3 from "assets/images/pages/golf-and-grow/patio_3.jpg";
import golfAndGrowDrivingRange1 from "assets/images/pages/golf-and-grow/driving_range_1.jpg";
import golfAndGrowDrivingRange2 from "assets/images/pages/golf-and-grow/driving_range_2.jpg";
import golfAndGrowDrivingRange3 from "assets/images/pages/golf-and-grow/driving_range_3.jpg";
import golfAndGrowCoaching1 from "assets/images/pages/golf-and-grow/coaching_1.jpg";
import golfAndGrowCoaching2 from "assets/images/pages/golf-and-grow/coaching_2.jpg";
import golfAndGrowCoaching3 from "assets/images/pages/golf-and-grow/coaching_3.jpg";
import frameworks from "assets/images/impact/frameworks.png";
import esgInitiatives from "assets/images/impact/esg-initiatives.png";
import portfolioManagement from "assets/images/impact/portfolio-management.png";
import mornington from "assets/images/portfolio/mornington.png";
import wollonggong from "assets/images/portfolio/wollonggong.png";
import AnalyzeIcon from "assets/icons/AnalyzeIcon";
import PlanIcon from "assets/icons/PlanIcon";

export const impacts = [
  {
    image: frameworks,
    title: "Framework",
    description: "Lorem ipsum dolor sit amet consectetur.",
    href: "/",
  },
  {
    image: esgInitiatives,
    title: "ESG Initiatives",
    description: "Lorem ipsum dolor sit amet consectetur.",
    href: "/",
  },
  {
    image: portfolioManagement,
    title: "Portfolio Management",
    description: "Lorem ipsum dolor sit amet consectetur.",
    href: "/",
  },
];

const whyUsTopContent = [
  {
    icon: AnalyzeIcon,
    title: "Global E-sport Revenue",
    description:
      "The potential of this nascent industry is huge. Dominated by a young, digital and global audience, the esports industry is fueled with economic opportunities measured by sponsorships, merchandising, ticket sales, advertising and media rights.",
  },
  {
    icon: PlanIcon,
    title: "SEA Esports Market Outlook",
    description:
      "Since 2016, Indonesia placed 2nd on the esports growing market. 2017 was when the esports market in Indonesia grew drastically. Today, Indonesia is one of the leading country for Esports in SEA Region.",
  },
];

const whyUsSecondContent = [
  {
    icon: AnalyzeIcon,
    title: "+75 Million",
    description: "Indonesian are gamers",
  },
  {
    icon: PlanIcon,
    title: "60% of Indonesian",
    description: "own smartphones and 17% of them are active gamers",
  },
  {
    icon: AnalyzeIcon,
    title: "14-35 years old",
    description: "from those are active gamers",
  },
  {
    icon: PlanIcon,
    title: "60% of Indonesian",
    description: "have consumtive behavior towards their hobby",
  },
  {
    icon: AnalyzeIcon,
    title: "8 hours a day",
    description: "Millenials spend their time online",
  },
  {
    icon: PlanIcon,
    title: "6 hours a week",
    description: "Millenials spend their time playing games",
  },
  {
    icon: AnalyzeIcon,
    title: "12 hours a week",
    description:
      "Millenials and other age group halved their TV viewership over the past 7 years",
  },
];

export const whyUs = {
  topContent: (
    <div className="grid grid-cols-1 gap-8 app-main-container sm:grid-cols-2">
      {whyUsTopContent.map((step, i) => {
        const Icon = step.icon;
        return (
          <div key={i} className="space-y-4">
            <div className="space-y-2 app-animation-translate-start">
              <Icon />
              <p className="text-sm font-bold uppercase md:text-base">
                {step.title}
              </p>
            </div>
            <p className="text-sm md:text-base app-animation-translate-start">
              {step.description}
            </p>
          </div>
        );
      })}
    </div>
  ),
  secondContent: (
    <div className="grid grid-cols-2 gap-8 app-main-container sm:grid-cols-3">
      {whyUsSecondContent.map((step, i) => {
        const Icon = step.icon;
        return (
          <div key={i}>
            <div className="space-y-2 app-animation-translate-start">
              <Icon />
              <p className="text-sm font-bold uppercase md:text-base">
                {step.title}
              </p>
            </div>
            <p className="text-sm md:text-base app-animation-translate-start">
              {step.description}
            </p>
          </div>
        );
      })}
    </div>
  ),
  ourServices: [
    {
      id: 1,
      title: "E-Sports consulting",
      link_url: "/esports-consulting",
      image_url:
        "https://images.pexels.com/photos/3165335/pexels-photo-3165335.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
    },
    {
      id: 2,
      title: "E-Sports event organizer",
      link_url: "/esports-eo",
      image_url:
        "https://storage.googleapis.com/nizerteklintasbumi/logo/sl-logo.jpeg",
    },
    {
      id: 3,
      title:
        "Production house specializing in OTT content and social media content",
      link_url: "/production-house",
      image_url:
        "https://images.pexels.com/photos/66134/pexels-photo-66134.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
    },
    {
      id: 4,
      title: "Digital marketing agency",
      link_url: "/digital-marketing",
      image_url:
        "https://images.pexels.com/photos/5678243/pexels-photo-5678243.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
    },
    {
      id: 5,
      title: "E-Sports team",
      link_url: "/esports-team",
      image_url:
        "https://assets.skor.id/crop/136x76:1228x690/x/photo/2020/10/05/1364398555.jpg",
    },
  ],
};

export const about = {
  description: (
    <>
      <p className="app-animation-translate-start">
        Our company was established in 2017 with the goal of developing esports
        ecosystem in Indonesia. We first started with Supreme League Arena,
        becoming the first cybercafe with ultimate esports ready hardware (
        240hz refresh rate monitors and top of the line CPU & GPU ) ensuring
        that our customers have the competitive edge in gaming.
      </p>
      <br />
      <p className="app-animation-translate-start">
        Today, our company has more than evolved from a small cybercafe to
        having a multitude of services in order to develop esports.
      </p>
      <br />
      <p className="app-animation-translate-start">
        We are the first company to create esports programs for television in
        Indonesia. Trusted by a cable television for more than 25 hours worth of
        esports content a month. We turn gaming into an entertainment watched by
        millions.
      </p>
      <br />
      <p className="app-animation-translate-start">
        As an esports event organizer we have done more than 100 events
        including big names from Tencent, Bytedance and trusted by
        internationally acclaimed companies to guide them in successfully
        engaging with the esports Indonesian market.
      </p>
      <br />
      <p className="app-animation-translate-start">
        We also developed an esports team in 2018 with the name Alterego Esports
        and in less than a year we are considered as one of the top 3 Indonesian
        esports team.
      </p>
      <br />
      <p className="app-animation-translate-start">
        In the everchanging esports industry we help our clients keep up with
        the trends and on ways to capitalize on the millions of millennial
        games, using esports as a gateway to reach this lucrative demographic.
      </p>
      <br />
      <p className="app-animation-translate-start">
        Our mission is to promote electronic sports as the next iteration of
        sports. Our vision is to turn esports into the biggest form of
        entertainment.
      </p>
    </>
  ),
  our_role_img: [
    {
      original:
        "https://storage.googleapis.com/nizerteklintasbumi/banner/Setup-Ecosystem_NLB.png",
      thumbnail:
        "https://storage.googleapis.com/nizerteklintasbumi/banner/Setup-Ecosystem_NLB.png",
    },
  ],
};

export const structure = {
  organization_structure_img: [
    {
      original:
        "https://storage.googleapis.com/nizerteklintasbumi/images/Hirarki_Draft.jpeg",
      thumbnail:
        "https://storage.googleapis.com/nizerteklintasbumi/images/Hirarki_Draft.jpeg",
    },
  ],
};

export const generalBrandsLogo = [
  {
    id: 1,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/bardi-logo.png",
  },
  {
    id: 2,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/blackshark-logo.webp",
  },
  {
    id: 3,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/boncabe-logo.png",
  },
  {
    id: 4,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/bri-logo.webp",
  },
  {
    id: 5,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/gojek-logo.png",
  },
  {
    id: 6,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/line-logo.png",
  },
  {
    id: 7,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/mandiri-logo.webp",
  },
  {
    id: 8,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/realme-logo.webp",
  },
  {
    id: 9,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/redbull-logo.png",
  },
  {
    id: 10,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/samsung-logo.svg",
  },
  {
    id: 11,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/ticketcom-logo.png",
  },
];

export const sponsoredByLogo = [
  {
    id: 1,
    name: "Mercury",
    image_url:
      "https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/427cae162f3b7ca7f71c362121975d05918b142c0d9374bc96233a185bd4c78d81a77a968a3552b95d1681d2a0fc4af6013c974b99bb83b575a02f1fbdd033593d852350fc8f4252c80f6d27693de63cdd49dc8a7c2f2b9c462db51d47d127e50b7303badda52c0a9b47704c0a4499fe1841e701311add489c15/file-1777899326867.png",
    href: "https://www.instagram.com/mercurysportsofficial/",
  },
  {
    id: 2,
    name: "Swing",
    image_url:
      "https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/5d5314249821c706268341d22000a6db8a8b0d27f512210391250d7a9bd554bc3166e5c4c8bf0d72de5e3de00f7812e123f0d66b8d834f384c0bf40425b060746c70a4fe8c26336e6f0fa065333576f3c299f90ceda9c2f2db62a34a31d56b6c6318812cdfcfc127845d4b9197fbebb774dbd496788226fe878c/file-1777969534459.jpg",
    href: "https://www.instagram.com/swingsports.id/",
  },
  {
    id: 3,
    name: "King Koil",
    image_url:
      "https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/0ab552e615b8b39258fba345838330c3fdc0193e027217404e5b51f7489af7c9b381460431868cdbd3a52f7ecd728ecf3bc0811323b6198f5b58c1b0f9cf852ef149d3b2bb9d0da06878d7e5d1cbc1104fa2f12ccee50878dddb04380e9bee4220c55f42590080020f3f201af400dfd1eda13c96b6e74548f08d/file-1778046766012.png",
    href: "https://www.instagram.com/kingkoil_id/",
  },
  {
    id: 4,
    name: "Merchmaniacs",
    image_url:
      "https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/3337b89357a4c23e99c45d460ed790a47b9bc938599a7300fa2806aa62d8128073f36a89568f6fb9348ff454574d7a59ce288ee46ad8e1d1bf6c4d7cf09ca0c503c06021fdf98a33e2f5a0bc04dfed6dcebc13a177bea8ff513db02dfa9244d874078c62d32cb82e3e13600d9244efe3197ca8512808436ceadc/file-1718955647557.png",
    href: "https://www.instagram.com/merchmaniacs/",
  },
  {
    id: 5,
    name: "BFW",
    image_url:
      "https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/393945a72d1ca3aa43ae417d3294e6d68c80ef9ff43e2d73d721c3da3d48585ccd50940b995b7708cb1bd1d3d7f441b4da172202310ffd43970b4ce2ea34d687ff85a88cc6239867b2316dd04d108f72c5efdcc1b09a16dba3402e2d3b6f97c22728d5f9f04c709e2fee9c64c9b0dcbecb771e17173d5d519caa/file-1718955444636.png",
    href: "https://www.instagram.com/bakhtera.id/?hl=en",
  },
  {
    id: 6,
    name: "Emo Trans",
    image_url:
      "https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/5138bd6613fd957503bfd103fc16bba59ff6b63ec7bb4b32e2e714dc43d08bce6f329ba3f73f482ab0d861bda947ed6d3b1efdd7617f190a55d66a4a78c2d3d261baa67afc9299405a6e7ed546d1a876e6e9951b5fcbb4a191a5e6bf3d54d93fb80eb66dc4143cf4a6d5d993618101efd7fb1050418d9eb47dbe/file-1718956188015.png",
    href: "https://www.instagram.com/emotrans.id/",
  },
  // {
  //   id: 1,
  //   name: "Rivera",
  //   image_url:
  //     "https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/fd6f745375ce57889e33e87b08ced2db71569d412d4992b234f1380333b08e91d80de66df776208d9f36fc32e48083bbb663498ad0f1b9b1b52a2f5bac364091f1bf01331b2d9c3169cda7142d2f24243a69d058c1673edcf01c104a808c3be5e2c825544e98d72d4c22e2988b1b7ef85fcd8d8dee214acb7db6/rez-file-1736504998431.jpg",
  //   href: "https://www.google.com/",
  // },
  // {
  //   id: 2,
  //   name: "BAIC",
  //   image_url:
  //     "https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/a44b39088e9e93d3d6b43a46bd8343f99797f4e26f8800b751df7f6b32c639f91a8255daae538232d8e6a64b925660b6683d8e101ec7fe3754e2eeb9dc403a3ee9e98c17fcacdfe591b9c01338dc2b994f96770b958ea55623635abe8bed6886d812e3f944d6d2a3e13057f8996bd56982b8ddb9813aa829cce1/file-1736416060170.png",
  //   href: "https://www.google.com/",
  // },
  // {
  //   id: 3,
  //   name: "Wonhae",
  //   image_url:
  //     "https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/107f6e55aeaf27c3eff99d59791800f06e512e197afac610e6fa816a280901070d5a13dcb36fc94da4bbc3a971e961e59bc5c5a5aca556f4dc57b285d9b8a4cb39c9e6abada7823d5c6ff191f7eaa65262194ef7c6951a8014976a4fe8b80e672f36802ddbfa0784f346faad79ceef9753b5aec3af2439f4ef4e/rez-file-1736416098311.png",
  //   href: "https://www.google.com/",
  // },
  // {
  //   id: 4,
  //   name: "VOLT",
  //   image_url:
  //     "https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/d7aa09593bd6defaf2d20e55bc3a777a285d47590ca325ad884a75b770bc187fb5c52b8234ccc09f8209ff2e74e5a92f7d6316aa5285eeb5ac2d3d2c1dd487a51936a20c35d96c2bb6bb1cbe9674f9421657c2cda0838eefb1f15a7a24ecbd054f66cde6a3d98dba933b9214f2ab85cbbe3b2be61db59c5b56e3/rez-file-1736505022816.jpg",
  //   href: "https://www.google.com/",
  // },
  // {
  //   id: 6,
  //   name: "Top Golf",
  //   image_url:
  //     "https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/d93fcf168457146b88cd35ee99e42821ee2c04f470cc0ccd0ff5f6d3f36e05166007c0cc54c10c6f1ca1e1c8bf6496a75381b1fee51f675c863854e6e2f5280c3dbbdbcc8f9a28539523363f2ed9caf95a575d3af34d74288e751515c4dfe9be5fe95aec67a97407d7754652c5c6192610dab50c33757d973df6/file-1736837507270.png",
  //   href: "https://www.google.com/",
  // },
  // {
  //   id: 7,
  //   name: "Rajawali Prost",
  //   image_url:
  //     "https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/1fb6a6484ee3064ebe4c828c1ff0f7e30f22a1b581756011a7189cd75bab91237aa21053f4bd43c0890a43fb69ac55fcc905acac8648f74c6f22ff0f0c79c63575ef32167c0108dc65226b606b4676d517bd51e8cb684e3e0ab25fef0967bd26d31c863819b98ddc7e7b3c08ca61edc483a9ecc6cb9b06995eb4/rez-file-1736505103376.png",
  //   href: "https://www.google.com/",
  // },
  // {
  //   id: 8,
  //   name: "Konig",
  //   image_url:
  //     "https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/5a921375146c304e2b666fad00dfb8f3a01b61c09533b25556e59e5d8bd96d69223f74f334e94ec85dcc7a19d7f73bf39a3cc0223cb148d422605e20e94e8f51ea2441e2e5e81b77f90522d01c0de8deabb831c78ffda40395e3f67f4e068ec582b4dc57bf487ae6f993168f801f45e0284dc3871e52d1d3ec69/rez-file-1736505135132.png",
  //   href: "https://www.google.com/",
  // },
  // {
  //   id: 11,
  //   name: "PLN Insurance",
  //   image_url:
  //     "https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/fb03d5f4f239b5682ec4c2b5a43f5718adfe10b7be0aa04feb16635aa2c7dba3183479a83c71fa026dbfbf0d1e47809901a7c8f353da0c625e373fea0b70a5558488a598bb6eff022cbc967088aff7e5596b792f45c3b366bddf576f4ebd87bd54050bf154175bb41a1d8942f0405dd5c06723b72a52e67b778a/file-1737473038508.jpg",
  //   href: "https://www.google.com/",
  // },
  // {
  //   id: 12,
  //   name: "Paramatech First",
  //   image_url:
  //     "https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/c7edfb6f2251437592e07c5cee2589d25dc3214f4ceac117bd40fcd23366bbeaf5561fbedf0b166a4e6173ddbc0b623cf755fc4a58eacb9f73e65504cb73e0a376ef33f282e13cb412d91c68d515ddbd4ad838e0f8b583c6f02ed13f04b56a53a60c26d5c7a2764f9b6e2a4a5d9abe32fd3d9d3b315c914d89b6/file-1737473071358.jpeg",
  //   href: "https://www.google.com/",
  // },
];

export const supportedByLogo = [
  {
    id: 1,
    name: "Smartscore",
    image_url:
      "https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/99fb5f33c62f94737fd98166160ed40ae1c3d57a2895bae22684728171553fc851bcd261c3aaabc249610dabf402be23e3d4420e0ebf702eb747ddab547f640b5ab0c900bdd2edd09c4f46d12af97fe38a9cf7b91bd90c334fd2db9c0c3a5fb1247a8bf837bf2959cc2413a41de7c86d27cf6b5bf50874c6d500/file-1778036382413.png",
    href: "https://www.instagram.com/smartscoreglobal/",
  },
  {
    id: 2,
    name: "Powergolf",
    image_url:
      "https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/1fabc3c2f3460c980e094002a76a035d24cc31bd13228e711ef2e46f881f7b9ff1e30a4fbfd654d6d272dec032309185035e07a4176e5517efff8ed03a26720a808ee4f7ef12a6a364ac6e95d312d3d1789d0779795fd4f8458d8855e905836e8afaa450c455f3e9763c184c2eb7e7e079e3f860cf882651d593/file-1777969314263.png",
    href: "https://www.instagram.com/powergolf.id/",
  },
  {
    id: 3,
    name: "Deorex",
    image_url:
      "https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/6c7768f50375a39d35002e21278f2615611952bbc4123aec96be9e9c5e3cbc14bc13f136d16617bb7ca85249827664dec69b159c6aab3975f2c82292bb18b8fe3dd8f17f8f413b2a4fe4adc24fb0a954326d5b9f88f6db0a0030f12f6e99c556ef786aea2de2fd13602827cc53ba63790bb4dd07266d972003a8/file-1778047560394.png",
    href: "https://www.instagram.com/deorex_official/",
  },
  {
    id: 4,
    name: "You C1000",
    image_url:
      "https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/fed497d424822fc0b59f2a458f8742db2f04a57631d4c4f4acd47ba6c0e86bce37173029ccc8312e1463f27a96e420ee3deed7ccd285e9727a04b7d06a786f04ed925196ea32ee439020d02d213bb02b4f82c69d11bf3705dc8207e5b1c7d117ce32d62702dd9563fcb1e5c51eab8a0a48428e4c6026e37c65a8/file-1778048078469.png",
    href: "https://www.instagram.com/youc1000vitamin/",
  },
  {
    id: 5,
    name: "Green Kosy",
    image_url:
      "https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/a90ccc82ebd31007b86e18a2b6b9e58d4e081bd8be4209bb5a3676a6f7a631db5503f6a22d90432ba9358a0b39f3ed3f42388e2f21ce175c5996f3b774da254b7361ddaa470ba0026ae3da01720093db878518e86d068f1ab9e2b5cbf5a4805e846871d6c9b4ea5efee485ee62c30f429a399a7ab4e832420b90/file-1778826256630.png",
    href: "https://www.greenkosy.co.id/",
  },
  // {
  //   id: 2,
  //   name: "BXPO",
  //   image_url:
  //     "https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/4a2f7f24389289dc082095c1e0cec634701da43d226c7e47a556859f6f6a03657df5fc405100e2704959a50ff4ea0b28a463fd9806927b8816a7a841f94b66dfee1945839f3344cac5da46d826fec1b713d7ea0b7ecad9e88712400c096fd47c3290f4fc632a815e6a110ddb4c94243d7148051e792110297ca6/file-1719205287022.PNG",
  //   href: "https://www.google.com/",
  // },
  // {
  //   id: 5,
  //   name: "BIG",
  //   image_url:
  //     "https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/2faa0888469544c76468cf492634907ef6f5d3e1721092c69be82d0413ae22ad06c64615edc34b58d1b49d4a2ca7132b3c4cb904e0eac7c20bc13e290018c02dc6c4b8d1412fcf43fc11d8e1425ca072b75be1e6d076db91b8f0ed8da54c8a98513602a67a9fe302f8ed224d529e4c428adbdb363ec219fac1d4/rez-file-1736416232340.png",
  //   href: "https://www.google.com/",
  // },
];

export const presentedByLogo = [
  {
    id: 1,
    name: "BIG Event Asia",
    image_url:
      "https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/bab0156cfcbd877f006cec71e21e68086442529a73cef3e7dbeb7d8d13895d28412dc447faf601ba595936346738fe0efc66d42120e85245c311247c09c39d58976906ba647d24935fe6ad5d18e22e884bf57bd1faac7361aaeff3c69fd44f53f9a38fa03a2a2f50038b1047d5ba8a151ae6ae054ff746ba7226/rez-file-1736416276911.png",
    href: "https://www.instagram.com/bigeventasia.id//",
  },
  // {
  //   id: 2,
  //   name: "Surya Indah",
  //   image_url:
  //     "https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/92103c849261ea5902ffbefd4d414f5d776d25e98e8b009472fd24fab8e857e9c328e4366e2e226c6f1fd0c8f3fc76914ebfc216fe379d5cebaafb10ea8b4e94d3c78f37e39d1e716b5216edcb558e89b1f2fe0063bc6252ca6255dbccd7213b81d9457c9f89258a8e0ffe53c474cf8bc4bc03ea72ddcd232a07/file-1736416034633.png",
  //   href: "https://www.google.com/",
  // },
  {
    id: 2,
    name: "Bakhtera Corp",
    image_url:
      "https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/17b25c8f47fd3376d1ee9f4e83a4cba211a5bb44875088ddd4a997879f07f4c6d69b4dfb0ea1c93de3f0491b9c4dd3ad75bdf586d872f6df0905da41691f1ec4ec68bfe2abf23aa40fc9e871fd2ae8ecebc4c462cf384d0931b92272b6a74d7360a755a6f1c548c705dbc1252f4b7fa284c000bc6fb85a959c7d/file-1777008691184.jpg",
    href: "https://www.instagram.com/bigeventasia.id/",
  },
];

export const communityPartnerLogo = [
  {
    id: 1,
    name: "BERGERACT",
    image_url:
      "https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/76aa3f4f3b2a0c120b14ac0e5c36a6f87ee796a4581666f8e3d50f5513352cb17aeb5344c9f7fd55c9070f54432234f18f4550eaf5f32db2d16b43f47c28c28d39d6a19bf864386a4c1784f7304fdfa381f6997bc2b6d7fa696de4f611a0d2a10d5443260ff8626ab1c990e6445592f2ccf1880bdfc965a2e385/file-1778826470606.png",
    href: "https://www.instagram.com/bergeract.id/",
  },
  {
    id: 2,
    name: "Golftrovert",
    image_url:
      "https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/0fcd67742ed82408a6e265f944df6ca6f44b50161ff0ed75baf692e83d98d893822c9a17567555a896d8777fb742f9db9881fe04e2bd1c581bc4d84489335113d24fbbf73313861ad4f14a4129da70f3b620a5065cc4230430b704ffa9f68a0a816154ddf6f9284c92b682d84c3d6cfd3c5cc3b277838903a0d1/file-1778826749957.png",
    href: "https://www.instagram.com/golftrovert/",
  },
  {
    id: 3,
    name: "BBGC",
    image_url:
      "https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/8cec655ddc0f05facb1fdea09548d02679e29a38e9a9e2149b36a355c463370dd666c3b7ef15353327015e5b540f395f12a320ac4ce5d5fe069258dc022f2db041243a7b6f05898efbd490978ce10f038016c8a2e9d41ba12e8ee8815c63a18d285db232f0fd6e82135375e0d0a2220c3e33d2f96c958b84776e/file-1778826897253.png",
    href: "https://www.instagram.com/bbgc_id/",
  },
  {
    id: 4,
    name: "Asperapi",
    image_url:
      "https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/8b4c0ff56683d92ab1bfd177d1e40d540b470897425d71d029f4128073946f1345dcb83e2b000057782efa13b0a0daa2f488788584f79f556db5ab166842dd76106da730143fc0d467570c5d631e98cd9dc15ff3e99446ef8a6ff7d3bdeceec68182fd85421e572f8d1343822600b7f984f78105673eab7b00a2/file-1778827054920.png",
    href: "https://www.instagram.com/asperapi_ieca/",
  },
  {
    id: 5,
    name: "Synergy Golf",
    image_url:
      "https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/8310a870b7d010d20435303189943d23f466db03cb93d92d553dc3fabf4230dd42dd74b2cd75995de0c1a42d9eca67aa0261200f24e0815a81a9e5c69ca005b0d41ded6e419df377c00ca282c2f0d86956b21ed2db07ca6a0eaa4a78feda1d56e5504523737cb7912026e5e053b9b4e201d11e4f49666eab117b/file-1778827151440.jpg",
    href: "https://www.instagram.com/synergygolf_id/",
  },
  {
    id: 6,
    name: "Powergolf Community",
    image_url:
      "https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/f77765d02b5349e0ca9d3f327a163ab1b0095f15ee13cd0fa13c9c2a1aa498a11eabde69eb48938f87ca6038bcf6828373098e58a58ee916e4175e556bad9dcc86253ae4d852c4990d60d326668533cb8e7e9c90980e6769012250baafd02aab3dff2ddb6290b97f89b18ad3c7e2515a0318594a0897a09e596a/file-1778827230059.png",
    href: "https://www.instagram.com/powergolf.id/",
  },
  // {
  //   id: 1,
  //   name: "El Golf",
  //   image_url:
  //     "https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/9ddda4dd7a20f1fdc89d326f9f2b50cf8a63222da2d55441a545bd6ac4046f86679278e358865b3ae04c84a7591e3a60c008d2ec944a48667771666dcae2bf63712a9a89263af60ec4cee8e629c54782efa5bb644a32f353a82f4a43437bd3939d8947196a0865345f00e5214649543902dbb2e5cec20ab7d3a4/file-1737473186814.jpeg",
  //   href: "https://www.google.com/",
  // },
  // {
  //   id: 2,
  //   name: "ISAA",
  //   image_url:
  //     "https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/87aa52f4388b55f85b6cbafbfcefae58dc394e60c04a5bf2f1a451dbdec99b2d916c0f63e7581176c622f8aeada5630cea13b8402adbe24852b8d39ec503c9614af7104399392396f236b0373a3cf8de49531154a3517b4244d10513a83ae69d39762c1adbd9490ec27f225f04a19e24d3fc50800976ca1d109d/file-1737473228614.jpg",
  //   href: "https://www.google.com/",
  // },
  // {
  //   id: 3,
  //   name: "NBGG",
  //   image_url:
  //     "https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/447f79990c1a40afa4a55ce4a7a32f2c1a6a09197699b48db68f65afd08251657c9448a429af1c5feb8a3f4e3c726ed6e58dd3bc6fc0dbfc638329a6843ba1dd2af98efe60c5c2ffae53f706e3b08b92add9218034dfe51a95668d4217ce67701329d5fea62996c4959ad813e75336311a5c8266e8ef44d3ecbb/file-1737473260734.png",
  //   href: "https://www.google.com/",
  // },
  // {
  //   id: 4,
  //   name: "Perpeju",
  //   image_url:
  //     "https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/a70937dca8e26ed662413ecca0143c929f5cc9ed58e19486b8bd1327f53365d16e47bb2dac0e1fdb25ceefb72436d1ce651da5c8133aefe71d855417db2bcfc069ea320fa971a0d1ce6699903d1157e59f4c772f2c06000d2b8f9edb911f338dca575512d0bfdfe155afb424c0cec2214bc513c4e35474d37b89/file-1737473286197.jpeg",
  //   href: "https://www.google.com/",
  // },
  // {
  //   id: 5,
  //   name: "Riverside Golf Club Blitar",
  //   image_url:
  //     "https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/12870efacd54d436d82ca03b92205a3021f612c98b08beffe34ec0d3db36a94a148e1748e7ffa14480f47d0bac1e8d46488ca22e9b80c2b73754c6112c82b80dc1c43c337ddd1bd0cbeea798869b3af4dc1ebb0eaf05125cbe01b52cedabe5102226799ee63f4ec8db741b27800975270f75e79a6fb4895ae46c/file-1737473317769.png",
  //   href: "https://www.google.com/",
  // },
];

export const ticketingByLogo = [
  {
    id: 1,
    name: "Cloudxier",
    image_url:
      "https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/b4d1290c6711cf20d5dda63611a56f04b15bdc1129f5ea3a848bdbdf3055ab024e14b3664244785c33015dd74314e79b9d18d8ee9d2dede39cb088937d8deb58999411a12605891e67a9109bd15d9fe536ece3a3f4a1b89903ef0639066f74d9c56152fffb8f5ca1e1a3705dd37dc0de70b33c52291bd78adaaf/file-1718956888002.png",
    href: "https://www.cloudxier.com/",
  },
];

export const djPerformByLogo = [
  {
    id: 1,
    name: "Ada Band",
    image_url:
      "https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/bef8766f2df01fcd9dac9d743349c8a5a1c5f6e4f88ee726986940929762b2e064da0eeda43ea4cbfe6c291532a4f15f720b1803a385de19eec82f1f81db3ebe96e9b3d6737e838d9e2c756df67d4d0924e3462f62004cb8080d5ab83d38965d0f080f82881d5efa63bf564640208158fef96eb522f7f2a71a02/rez-file-1736416350731.jpg",
  },
];

export const venueByLogo = [
  {
    id: 1,
    name: "Damai Indah Golf",
    image_url:
      "https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/9dee870f8cd71600d4d32083aea6b9559bf86c9c057d35b8ef10ef27771a69acb5058756c51160b09be3ae14e685602c5fa54de1b787a9e6659dc517bfb20cae26a9db1f8fd3324ac6375635df8f8520d7b3895f53fdc42de68f254ebba4db241f79eb3dc00bcb877df77b1e147f39067afaa6f6737761e33854/file-1777008720539.png",
    href: "https://www.instagram.com/damaiindahgolfofficial/",
  },
];

export const mediaByLogo = [
  {
    id: 1,
    name: "BO Magz",
    image_url:
      "https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/62225d2bc5f9f023c00007f2e0dfcbfc1d6e059c9f5cb5e0c1eacd30e3ebb1ef5242ac889a79cf8fa3d374cf011cab404a12767809dfe0875ebfdb9052f4414e8271c1ad31838d8343648bdc359298dc4f7af0c40b2e13143a136b28e40512d71632a890a938aadc6bfd8649ef8eb168cdb1f176a4aa2f36b8b9/file-1777969084879.png",
    href: "https://bomagz.com/",
  },
];

export const gamePublishersLogo = [
  {
    id: 1,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/game-publishers/gamevil-logo.jpeg",
  },
  {
    id: 2,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/game-publishers/garena-logo.png",
  },
  {
    id: 3,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/game-publishers/igg-logo.png",
  },
  {
    id: 4,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/game-publishers/linepod-logo.png",
  },
  {
    id: 5,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/game-publishers/megaxus-logo.png",
  },
  {
    id: 6,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/game-publishers/mihoyo-logo.svg",
  },
  {
    id: 7,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/game-publishers/moonton-logo.png",
  },
  {
    id: 8,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/game-publishers/riot-logo.png",
  },
  {
    id: 9,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/game-publishers/supercell-logo.png",
  },
  {
    id: 10,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/game-publishers/tencent-logo.webp",
  },
  {
    id: 11,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/game-publishers/vng-logo.png",
  },
];

export const ottContentBrand = [
  {
    id: 1,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/ott-content/firstmedia-logo.png",
  },
  {
    id: 2,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/ott-content/maxstream-logo.png",
  },
  {
    id: 3,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/ott-content/nimotv-logo.png",
  },
  {
    id: 4,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/ott-content/snackvideo-logo.png",
  },
  {
    id: 5,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/ott-content/useetv-logo.png",
  },
  {
    id: 6,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/ott-content/vidio-logo.png",
  },
];

export const internetProvidersBrand = [
  {
    id: 1,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/internet-providers/axis-logo.png",
  },
  {
    id: 2,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/internet-providers/indihome-logo.png",
  },
  {
    id: 3,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/internet-providers/myrepublic-logo.webp",
  },
  {
    id: 4,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/internet-providers/telkomsel-logo.png",
  },
];

export const phClientsLogo = [
  {
    id: 1,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/ott-content/firstmedia-logo.png",
  },
  {
    id: 2,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/ott-content/vidio-logo.png",
  },
  {
    id: 3,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/ott-content/maxstream-logo.png",
  },
  {
    id: 4,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/game-publishers/tencent-logo.webp",
  },
  {
    id: 5,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/game-publishers/supercell-logo.png",
  },
  {
    id: 6,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/ott-content/nimotv-logo.png",
  },
  {
    id: 7,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/internet-providers/telkomsel-logo.png",
  },
  {
    id: 8,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/redbull-logo.png",
  },
];

export const phVideoBanner = [
  {
    id: 1,
    title: "Love in Game",
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/banner/love-in-game-banner.png",
    link_url: "https://maxstream.tv/movies/0_xp5n50sz",
  },
];

export const phYoutubeVideoLinks = [
  {
    id: 1,
    title: "PUBG Mobile Jawara Community",
    video_url: "https://www.youtube.com/embed/iM--q-HAIUI?si=lIrzxVxp2F229AE_",
  },
  {
    id: 2,
    title: "AOC Valentine Campaign",
    video_url: "https://www.youtube.com/embed/ZT2XhYtwrYs?si=P_8tWcb332nFepAE",
  },
  {
    id: 3,
    title: "AGON by AOC Campaign",
    video_url: "https://www.youtube.com/embed/V_Nrj3FSKnw?si=WjzvnV5_BpVfm8RA",
  },
];

export const phGdriveVideoLinks = [
  {
    id: 1,
    title: "E-Sports Time",
    video_url:
      "https://drive.google.com/file/d/1rgdpg_yzKCPxw98SFB5Yk4fEJ-XkERQG/preview",
  },
  {
    id: 2,
    title: "Mabar Yuk!",
    video_url:
      "https://drive.google.com/file/d/1c__-g-W5yImfNGURE3Eaaqu162yFQ9hh/preview",
  },
  {
    id: 3,
    title: "Forgotten Path",
    video_url:
      "https://drive.google.com/file/d/1OjPGg0Vd5AZW3WE6-ORaHOUDoAwbWP9X/preview",
  },
];

export const phStudioImages = [
  {
    original:
      "https://images.pexels.com/photos/668296/pexels-photo-668296.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
    thumbnail:
      "https://images.pexels.com/photos/668296/pexels-photo-668296.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
  },
  {
    original:
      "https://images.pexels.com/photos/66134/pexels-photo-66134.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
    thumbnail:
      "https://images.pexels.com/photos/66134/pexels-photo-66134.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
  },
  {
    original:
      "https://images.pexels.com/photos/2228831/pexels-photo-2228831.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
    thumbnail:
      "https://images.pexels.com/photos/2228831/pexels-photo-2228831.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
  },
];

export const phStudio2Images = [
  {
    original:
      "https://images.pexels.com/photos/668296/pexels-photo-668296.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
    thumbnail:
      "https://images.pexels.com/photos/668296/pexels-photo-668296.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
  },
  {
    original:
      "https://images.pexels.com/photos/66134/pexels-photo-66134.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
    thumbnail:
      "https://images.pexels.com/photos/66134/pexels-photo-66134.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
  },
  {
    original:
      "https://images.pexels.com/photos/2228831/pexels-photo-2228831.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
    thumbnail:
      "https://images.pexels.com/photos/2228831/pexels-photo-2228831.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
  },
];

export const phDigitalAssetImages = [
  {
    original:
      "https://images.pexels.com/photos/668296/pexels-photo-668296.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
    thumbnail:
      "https://images.pexels.com/photos/668296/pexels-photo-668296.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
  },
  {
    original:
      "https://images.pexels.com/photos/66134/pexels-photo-66134.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
    thumbnail:
      "https://images.pexels.com/photos/66134/pexels-photo-66134.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
  },
  {
    original:
      "https://images.pexels.com/photos/2228831/pexels-photo-2228831.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
    thumbnail:
      "https://images.pexels.com/photos/2228831/pexels-photo-2228831.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
  },
];

export const publishingPrClients = [
  {
    id: 1,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/ott-content/firstmedia-logo.png",
  },
  {
    id: 2,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/ott-content/vidio-logo.png",
  },
  {
    id: 3,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/ott-content/maxstream-logo.png",
  },
  {
    id: 4,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/game-publishers/tencent-logo.webp",
  },
  {
    id: 5,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/game-publishers/supercell-logo.png",
  },
  {
    id: 6,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/ott-content/nimotv-logo.png",
  },
  {
    id: 7,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/internet-providers/telkomsel-logo.png",
  },
  {
    id: 8,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/redbull-logo.png",
  },
];

export const technoMediaPartnerLogo = [
  {
    id: 1,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/techno/carisinyal.png",
  },
  {
    id: 2,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/techno/dormatekno.png",
  },
  {
    id: 3,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/techno/droidlime.png",
  },
  {
    id: 4,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/techno/duerclockingid.png",
  },
  {
    id: 5,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/techno/gadetapa.png",
  },
  {
    id: 6,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/techno/gadgetdiva.png",
  },
  {
    id: 7,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/techno/gadgetsquad.png",
  },
  {
    id: 8,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/techno/gadgettren.png",
  },
  {
    id: 9,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/techno/gawaimikro.png",
  },
  {
    id: 10,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/techno/gayafone.png",
  },
  {
    id: 11,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/techno/gizmologi.png",
  },
  {
    id: 12,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/techno/hardwareholic.png",
  },
  {
    id: 13,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/techno/hittekno.png",
  },
  {
    id: 14,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/techno/infokom.png",
  },
  {
    id: 15,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/techno/inilahcom.png",
  },
  {
    id: 16,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/techno/jagatreview.png",
  },
  {
    id: 17,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/techno/kincir.png",
  },
  {
    id: 18,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/techno/mbittekno.png",
  },
  {
    id: 19,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/techno/nextren.png",
  },
  {
    id: 20,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/techno/pricebook.png",
  },
  {
    id: 21,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/techno/pulsa.png",
  },
  {
    id: 22,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/techno/review.png",
  },
  {
    id: 23,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/techno/selular.png",
  },
  {
    id: 24,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/techno/skor.png",
  },
  {
    id: 25,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/techno/techbiz.png",
  },
  {
    id: 26,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/techno/techdaily.png",
  },
  {
    id: 27,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/techno/technologue.png",
  },
  {
    id: 28,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/techno/tekid.png",
  },
  {
    id: 29,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/techno/teknogav.png",
  },
  {
    id: 30,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/techno/telkoid.png",
  },
  {
    id: 31,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/techno/trenteknologi.png",
  },
  {
    id: 32,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/techno/yangcanggih.png",
  },
  {
    id: 33,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/techno/youngster.png",
  },
];

export const gamingMediaPartnerLogo = [
  {
    id: 1,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/gaming/d.png",
  },
  {
    id: 2,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/gaming/duniagames.png",
  },
  {
    id: 3,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/gaming/duniaku.png",
  },
  {
    id: 4,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/gaming/esportsid.png",
  },
  {
    id: 5,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/gaming/esportsku.png",
  },
  {
    id: 6,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/gaming/gamebrott.png",
  },
  {
    id: 7,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/gaming/gamedaim.png",
  },
  {
    id: 8,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/gaming/gamefever.png",
  },
  {
    id: 9,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/gaming/gameholic.png",
  },
  {
    id: 10,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/gaming/ggwpid.png",
  },
  {
    id: 11,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/gaming/gridgames.png",
  },
  {
    id: 12,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/gaming/gudanggaming.png",
  },
  {
    id: 13,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/gaming/hybrid.png",
  },
  {
    id: 14,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/gaming/indoesports.png",
  },
  {
    id: 15,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/gaming/indogames.png",
  },
  {
    id: 16,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/gaming/jagatplay.png",
  },
  {
    id: 17,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/gaming/kabargames.png",
  },
  {
    id: 18,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/gaming/kaorinusantara.png",
  },
  {
    id: 19,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/gaming/kincir.png",
  },
  {
    id: 20,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/gaming/kotakgame.png",
  },
  {
    id: 21,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/gaming/mastergame.png",
  },
  {
    id: 22,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/gaming/onesports.png",
  },
  {
    id: 23,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/gaming/revivaltv.png",
  },
  {
    id: 24,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/gaming/skorid.png",
  },
  {
    id: 25,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/gaming/skyegrid.png",
  },
  {
    id: 26,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/gaming/yodu.png",
  },
];

export const generalMediaPartnerLogo = [
  {
    id: 1,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/general/akuratco.png",
  },
  {
    id: 2,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/general/alix.png",
  },
  {
    id: 3,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/general/antv.svg.png",
  },
  {
    id: 4,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/general/beritasatu.png",
  },
  {
    id: 5,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/general/bisnisindonesia.png",
  },
  {
    id: 6,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/general/canggihid.png",
  },
  {
    id: 7,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/general/cnn.svg.png",
  },
  {
    id: 8,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/general/dailysocialid.png",
  },
  {
    id: 9,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/general/detikcom.png",
  },
  {
    id: 10,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/general/jawapos.png",
  },
  {
    id: 11,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/general/jpnn.png",
  },
  {
    id: 12,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/general/kapanlagi.svg.png",
  },
  {
    id: 13,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/general/kompas.png",
  },
  {
    id: 14,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/general/kompascom.png",
  },
  {
    id: 15,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/general/kompastekno.png",
  },
  {
    id: 16,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/general/kumparan.png",
  },
  {
    id: 17,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/general/liputan6.svg.png",
  },
  {
    id: 18,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/general/marketeers.png",
  },
  {
    id: 19,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/general/merahputih.png",
  },
  {
    id: 20,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/general/merdekacom.png",
  },
  {
    id: 21,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/general/okezone.png",
  },
  {
    id: 22,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/general/rakyatmerdeka.png",
  },
  {
    id: 23,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/general/republika.png",
  },
  {
    id: 24,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/general/sindonews.png",
  },
  {
    id: 25,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/general/suaracom.png",
  },
  {
    id: 26,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/general/tagarid.png",
  },
  {
    id: 27,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/general/tempo.png",
  },
  {
    id: 28,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/general/tvone.png",
  },
  {
    id: 29,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/general/uzone.png",
  },
  {
    id: 30,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/general/viva.png",
  },
  {
    id: 31,
    image_url:
      "https://storage.googleapis.com/nizerteklintasbumi/logo/media-partner/general/wartaekonomi.png",
  },
];

export const promotionalImages = [
  {
    original:
      "https://images.pexels.com/photos/668296/pexels-photo-668296.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
    thumbnail:
      "https://images.pexels.com/photos/668296/pexels-photo-668296.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
  },
  {
    original:
      "https://images.pexels.com/photos/66134/pexels-photo-66134.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
    thumbnail:
      "https://images.pexels.com/photos/66134/pexels-photo-66134.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
  },
  {
    original:
      "https://images.pexels.com/photos/2228831/pexels-photo-2228831.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
    thumbnail:
      "https://images.pexels.com/photos/2228831/pexels-photo-2228831.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
  },
];

export const marketingCatImages = [
  {
    original:
      "https://images.pexels.com/photos/668296/pexels-photo-668296.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
    thumbnail:
      "https://images.pexels.com/photos/668296/pexels-photo-668296.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
  },
  {
    original:
      "https://images.pexels.com/photos/66134/pexels-photo-66134.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
    thumbnail:
      "https://images.pexels.com/photos/66134/pexels-photo-66134.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
  },
  {
    original:
      "https://images.pexels.com/photos/2228831/pexels-photo-2228831.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
    thumbnail:
      "https://images.pexels.com/photos/2228831/pexels-photo-2228831.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
  },
];

export const dMarketingCatImages = [
  {
    original:
      "https://images.pexels.com/photos/668296/pexels-photo-668296.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
    thumbnail:
      "https://images.pexels.com/photos/668296/pexels-photo-668296.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
  },
  {
    original:
      "https://images.pexels.com/photos/66134/pexels-photo-66134.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
    thumbnail:
      "https://images.pexels.com/photos/66134/pexels-photo-66134.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
  },
  {
    original:
      "https://images.pexels.com/photos/2228831/pexels-photo-2228831.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
    thumbnail:
      "https://images.pexels.com/photos/2228831/pexels-photo-2228831.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
  },
];

export const aeImages = [
  {
    original:
      "https://cdn.vcgamers.com/news/wp-content/uploads/2023/02/Logo-Alterego-1.jpg",
    thumbnail:
      "https://cdn.vcgamers.com/news/wp-content/uploads/2023/02/Logo-Alterego-1.jpg",
    description: "Alter Ego 1",
  },
  {
    original:
      "https://awsimages.detik.net.id/community/media/visual/2022/08/03/ini-dia-roster-baru-alter-ego-esports-di-mpl-id-s10_169.png?w=1200",
    thumbnail:
      "https://awsimages.detik.net.id/community/media/visual/2022/08/03/ini-dia-roster-baru-alter-ego-esports-di-mpl-id-s10_169.png?w=1200",
    description: "Alter Ego 2",
  },
  {
    original:
      "https://d1tgyzt3mf06m9.cloudfront.net/v3-staging/2023/08/230827-PMSL-SEA-Fall-2023-Alter-Ego-Juara.png",
    thumbnail:
      "https://d1tgyzt3mf06m9.cloudfront.net/v3-staging/2023/08/230827-PMSL-SEA-Fall-2023-Alter-Ego-Juara.png",
    description: "Alter Ego 3",
  },
];

export const portfolio = [
  {
    id: 1,
    image: mornington,
    name: "Mornington peninsula villas",
    description: (
      <>
        <p className="app-animation-translate-start">
          Lorem ipsum dolor sit amet consectetur.Id magna convallis diam
          condimentum felis convallis.Sed faucibus sagittis a sed commodo
          fermentum massa.Mauris venenatis lacus at semper.Purus tortor massa ac
          ultrices gravida in.Viverra ipsum in viverra nisl dignissim gravida
          vitae.Scelerisque sagittis sem dignissim eleifend ac.
        </p>
        <br />
        <p className="app-animation-translate-start">
          Lorem ipsum dolor sit amet consectetur.Id magna convallis diam
          condimentum felis convallis.Sed faucibus sagittis a sed commodo
          fermentum massa.Mauris venenatis lacus at semper.Purus tortor massa ac
          ultrices gravida in.Viverra ipsum in viverra nisl dignissim gravida
          vitae.Scelerisque sagittis sem dignissim eleifend ac.
        </p>
        <br />
        <p className="app-animation-translate-start">
          Lorem ipsum dolor sit amet consectetur.Id magna convallis diam
          condimentum felis convallis.Sed faucibus sagittis a sed commodo
          fermentum massa.Mauris venenatis lacus at semper.Purus tortor massa ac
          ultrices gravida in.Viverra ipsum in viverra nisl dignissim gravida
          vitae.Scelerisque sagittis sem dignissim eleifend ac.
        </p>
        <br />
        <p className="app-animation-translate-start">
          Lorem ipsum dolor sit amet consectetur.Id magna convallis diam
          condimentum felis convallis.Sed faucibus sagittis a sed commodo
          fermentum massa.Mauris venenatis lacus at semper.Purus tortor massa ac
          ultrices gravida in.Viverra ipsum in viverra nisl dignissim gravida
          vitae.Scelerisque sagittis sem dignissim eleifend ac.
        </p>
      </>
    ),
    section1Photos: [mornington, mornington],
    section2Photos: [mornington, mornington],
    tagline:
      "Modern living reimagined. Bringing the balance for luxury and minimalist.",
  },
  {
    id: 2,
    image: wollonggong,
    name: "Wollonggong private residence",
    description: (
      <>
        <p className="app-animation-translate-start">
          Lorem ipsum dolor sit amet consectetur.Id magna convallis diam
          condimentum felis convallis.Sed faucibus sagittis a sed commodo
          fermentum massa.Mauris venenatis lacus at semper.Purus tortor massa ac
          ultrices gravida in.Viverra ipsum in viverra nisl dignissim gravida
          vitae.Scelerisque sagittis sem dignissim eleifend ac.
        </p>
        <br />
        <p className="app-animation-translate-start">
          Lorem ipsum dolor sit amet consectetur.Id magna convallis diam
          condimentum felis convallis.Sed faucibus sagittis a sed commodo
          fermentum massa.Mauris venenatis lacus at semper.Purus tortor massa ac
          ultrices gravida in.Viverra ipsum in viverra nisl dignissim gravida
          vitae.Scelerisque sagittis sem dignissim eleifend ac.
        </p>
        <br />
        <p className="app-animation-translate-start">
          Lorem ipsum dolor sit amet consectetur.Id magna convallis diam
          condimentum felis convallis.Sed faucibus sagittis a sed commodo
          fermentum massa.Mauris venenatis lacus at semper.Purus tortor massa ac
          ultrices gravida in.Viverra ipsum in viverra nisl dignissim gravida
          vitae.Scelerisque sagittis sem dignissim eleifend ac.
        </p>
        <br />
        <p className="app-animation-translate-start">
          Lorem ipsum dolor sit amet consectetur.Id magna convallis diam
          condimentum felis convallis.Sed faucibus sagittis a sed commodo
          fermentum massa.Mauris venenatis lacus at semper.Purus tortor massa ac
          ultrices gravida in.Viverra ipsum in viverra nisl dignissim gravida
          vitae.Scelerisque sagittis sem dignissim eleifend ac.
        </p>
      </>
    ),
    section1Photos: [wollonggong, wollonggong],
    section2Photos: [wollonggong, wollonggong],
    tagline:
      "Modern living reimagined. Bringing the balance for luxury and minimalist.",
  },
  {
    id: 3,
    image: mornington,
    name: "Mornington peninsula villas",
    description: (
      <>
        <p className="app-animation-translate-start">
          Lorem ipsum dolor sit amet consectetur.Id magna convallis diam
          condimentum felis convallis.Sed faucibus sagittis a sed commodo
          fermentum massa.Mauris venenatis lacus at semper.Purus tortor massa ac
          ultrices gravida in.Viverra ipsum in viverra nisl dignissim gravida
          vitae.Scelerisque sagittis sem dignissim eleifend ac.
        </p>
        <br />
        <p className="app-animation-translate-start">
          Lorem ipsum dolor sit amet consectetur.Id magna convallis diam
          condimentum felis convallis.Sed faucibus sagittis a sed commodo
          fermentum massa.Mauris venenatis lacus at semper.Purus tortor massa ac
          ultrices gravida in.Viverra ipsum in viverra nisl dignissim gravida
          vitae.Scelerisque sagittis sem dignissim eleifend ac.
        </p>
        <br />
        <p className="app-animation-translate-start">
          Lorem ipsum dolor sit amet consectetur.Id magna convallis diam
          condimentum felis convallis.Sed faucibus sagittis a sed commodo
          fermentum massa.Mauris venenatis lacus at semper.Purus tortor massa ac
          ultrices gravida in.Viverra ipsum in viverra nisl dignissim gravida
          vitae.Scelerisque sagittis sem dignissim eleifend ac.
        </p>
        <br />
        <p className="app-animation-translate-start">
          Lorem ipsum dolor sit amet consectetur.Id magna convallis diam
          condimentum felis convallis.Sed faucibus sagittis a sed commodo
          fermentum massa.Mauris venenatis lacus at semper.Purus tortor massa ac
          ultrices gravida in.Viverra ipsum in viverra nisl dignissim gravida
          vitae.Scelerisque sagittis sem dignissim eleifend ac.
        </p>
      </>
    ),
    section1Photos: [mornington, mornington],
    section2Photos: [mornington, mornington],
    tagline:
      "Modern living reimagined. Bringing the balance for luxury and minimalist.",
  },
  {
    id: 4,
    image: wollonggong,
    name: "Wollonggong private residence",
    description: (
      <>
        <p className="app-animation-translate-start">
          Lorem ipsum dolor sit amet consectetur.Id magna convallis diam
          condimentum felis convallis.Sed faucibus sagittis a sed commodo
          fermentum massa.Mauris venenatis lacus at semper.Purus tortor massa ac
          ultrices gravida in.Viverra ipsum in viverra nisl dignissim gravida
          vitae.Scelerisque sagittis sem dignissim eleifend ac.
        </p>
        <br />
        <p className="app-animation-translate-start">
          Lorem ipsum dolor sit amet consectetur.Id magna convallis diam
          condimentum felis convallis.Sed faucibus sagittis a sed commodo
          fermentum massa.Mauris venenatis lacus at semper.Purus tortor massa ac
          ultrices gravida in.Viverra ipsum in viverra nisl dignissim gravida
          vitae.Scelerisque sagittis sem dignissim eleifend ac.
        </p>
        <br />
        <p className="app-animation-translate-start">
          Lorem ipsum dolor sit amet consectetur.Id magna convallis diam
          condimentum felis convallis.Sed faucibus sagittis a sed commodo
          fermentum massa.Mauris venenatis lacus at semper.Purus tortor massa ac
          ultrices gravida in.Viverra ipsum in viverra nisl dignissim gravida
          vitae.Scelerisque sagittis sem dignissim eleifend ac.
        </p>
        <br />
        <p className="app-animation-translate-start">
          Lorem ipsum dolor sit amet consectetur.Id magna convallis diam
          condimentum felis convallis.Sed faucibus sagittis a sed commodo
          fermentum massa.Mauris venenatis lacus at semper.Purus tortor massa ac
          ultrices gravida in.Viverra ipsum in viverra nisl dignissim gravida
          vitae.Scelerisque sagittis sem dignissim eleifend ac.
        </p>
      </>
    ),
    section1Photos: [wollonggong, wollonggong],
    section2Photos: [wollonggong, wollonggong],
    tagline:
      "Modern living reimagined. Bringing the balance for luxury and minimalist.",
  },
];

export const posts = [
  {
    image: mornington,
    title: "Mornington peninsula villas",
    description:
      "Lorem ipsum dolor sit amet consectetur. Id magna convallis diam condimentum felis convallis. ",
  },
  {
    image: mornington,
    title: "Mornington peninsula villas",
    description:
      "Lorem ipsum dolor sit amet consectetur. Id magna convallis diam condimentum felis convallis. ",
  },
  {
    image: mornington,
    title: "Mornington peninsula villas",
    description:
      "Lorem ipsum dolor sit amet consectetur. Id magna convallis diam condimentum felis convallis. ",
  },
];

export const golfAndGrowPatioImages = [
  { original: golfAndGrowPatio1, thumbnail: golfAndGrowPatio1 },
  { original: golfAndGrowPatio2, thumbnail: golfAndGrowPatio2 },
  { original: golfAndGrowPatio3, thumbnail: golfAndGrowPatio3 },
];

export const golfAndGrowDrivingRangeImages = [
  { original: golfAndGrowDrivingRange1, thumbnail: golfAndGrowDrivingRange1 },
  { original: golfAndGrowDrivingRange2, thumbnail: golfAndGrowDrivingRange2 },
  { original: golfAndGrowDrivingRange3, thumbnail: golfAndGrowDrivingRange3 },
];

export const golfAndGrowCoachingImages = [
  { original: golfAndGrowCoaching1, thumbnail: golfAndGrowCoaching1 },
  { original: golfAndGrowCoaching2, thumbnail: golfAndGrowCoaching2 },
  { original: golfAndGrowCoaching3, thumbnail: golfAndGrowCoaching3 },
];
